import { NgClass } from '@angular/common';
import {
  ApplicationRef,
  ChangeDetectionStrategy,
  Component,
  OnChanges,
  OnDestroy,
  OnInit,
  input,
  viewChild,
} from '@angular/core';
import { DotCMSBasicContentlet } from '@dotcms/types';
import { NgbCarousel, NgbSlide } from '@ng-bootstrap/ng-bootstrap';
import { ReplaySubject, Subject, map, take, takeUntil } from 'rxjs';

import { whenTruthy } from 'ish-core/utils/operators';

import { DotCmsUveContentRenderComponent } from '../../components/dot-cms-uve-content-render/dot-cms-uve-content-render.component';
import { CustomDotCmsUveContentletHelper } from '../../models/contentlet/custom-dot-cms-uve-contentlet.helper';
import { CarouselContentlet } from '../../models/dot-cms-uve-contentlet.model';
import { sliceContents } from '../../utils/dot-cms-uve-utils';

@Component({
  selector: 'custom-dot-cms-carousel',
  templateUrl: './dot-cms-uve-carousel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DotCmsUveContentRenderComponent, NgbCarousel, NgbSlide, NgClass],
})
export class DotCmsUveCarouselComponent implements OnInit, OnChanges, OnDestroy {
  readonly contentlet = input<CarouselContentlet>();
  // contentlet: CustomDotCmsContentlet;
  slideItems: number;
  posIni: number;
  readonly carousel = viewChild<NgbCarousel>('ngbCarousel');

  carouselContents: DotCMSBasicContentlet[];
  private destroy$ = new Subject<void>();
  itemGridSize = 12;
  contentTypes: string[] = ['banners', 'images', 'videos', 'productsTooltip'];
  identifier$ = new ReplaySubject<string>(1);
  constructor(private appRef: ApplicationRef) {}

  ngOnInit() {
    this.carouselContents = CustomDotCmsUveContentletHelper.getSortedSubContentlets(
      this.contentlet(),
      this.contentTypes,
      'sortOrder'
    );
    //No.of.Items Logic
    this.carouselContents = sliceContents(this.contentlet().slideItems, this.carouselContents);
  }

  ngOnChanges(): void {
    //Loop Logic
    this.appRef?.isStable
      .pipe(
        whenTruthy(),
        map(() => (this.contentlet()?.startCycling ? this.contentlet()?.slideInterval : 0)),
        take(1),
        takeUntil(this.destroy$)
      )
      .subscribe(val => {
        const carousel = this.carousel();
        if (val && val !== 0 && carousel) {
          carousel.interval = +val;
          carousel.cycle();
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  cssClasses(contentlet: CarouselContentlet): string {
    if (contentlet?.maxWidth.length > 0) {
      return 'default-carousel-class full-width-carousel';
    }
    return 'default-carousel-class';
  }
  moveSlider(pos: number) {
    const offset = this.posIni - pos;
    if (offset < -100) {
      this.carousel().prev();
    }

    if (offset > 100) {
      this.carousel().next();
    }
  }
}
